<template>
  <li
    v-if="question"
    class="mt-4"
  >
    <p
      class="header"
      :class="{ required: question.required }"
    >
      {{ question.label }}
    </p>
    <ConfirmButtons
      :key="'paidHelp'"
      v-model="paidHelp"
      v-validate="{ required: question.required }"
      string
      class="mb-4"
      :error-messages="errors.collect('paidHelp')"
      data-vv-as=" "
      :disabled="readOnly"
      :data-vv-name="'paidHelp'"
    />
    <div
      v-if="showHelpExplanation"
      class="mt-4"
    >
      <p
        class="fw-600 mt-3"
        :class="{ required: questionExplanation.required }"
      >
        {{ questionExplanation.label }}
      </p>
      <v-textarea
        v-model="helpExplanation"
        v-validate="{ ...regularLongText(questionExplanation.required) }"
        :placeholder="$t('placeholders.add_text')"
        :error-messages="errors.collect('helpExplanation')"
        data-vv-as=" "
        data-vv-name="helpExplanation"
        :required="questionExplanation.required"
        :disabled="readOnly"
      />
    </div>
  </li>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import ConfirmButtons from '@/components/widgets/sheet/ConfirmButtons';
const { mapFields } = createHelpers({
    getterType: 'specialistPackage/getLawyersData',
    mutationType: 'specialistPackage/updateLawyersData'
});
export default {
    name: 'PaidHelp',
    components: { ConfirmButtons },
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        question () {
            return this.$store.getters['specialistPackage/getQuestions'].paid_help;
        },
        questionExplanation () {
            return this.$store.getters['specialistPackage/getQuestions'].help_explanation;
        },
        ...mapFields(['paidHelp', 'helpExplanation', 'freeHelp']),
        showHelpExplanation () {
            return this.paidHelp === 'yes' || this.freeHelp === 'yes';
        }
    },
    watch: {
        showHelpExplanation (val) {
            if (val === false) {
                this.helpExplanation = null;
            }
        }
    }
};
</script>

<style scoped></style>
